var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lesson-bk-wrap"},[(_vm.unSigned || _vm.lessonInfo.courseNoteCount <= 0)?_c('span',{staticClass:"lesson-bk-noclick"},[_vm._v("备课 ")]):_c('span',{staticClass:"lesson-bk"},[_c('a',{on:{"click":_vm.handleBeike}},[_vm._v("备课")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }